/**
 * Enum for Report Statuses
 * @readonly
 * @enum {name: {value: number}}
 */

export const ReportStatusesEnum = Object.freeze({ InProgress: 0, Ready: 1, Faulted: 2 });
